import React from 'react';
type AdvisorsSvgProps = {
  stroke: string;
};

export const StocksSvg: React.FC<AdvisorsSvgProps> = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.33334 1.33333V4.39999M5.33334 12.6667V16.6667"
      stroke={props.stroke}
      stroke-linecap="round"
    />
    <path
      d="M4.63334 4.66666C4.28856 4.66666 3.9579 4.80362 3.7141 5.04742C3.47031 5.29121 3.33334 5.62188 3.33334 5.96666V11.3667C3.33334 11.5374 3.36697 11.7064 3.4323 11.8641C3.49763 12.0219 3.59339 12.1652 3.7141 12.2859C3.83482 12.4066 3.97813 12.5024 4.13586 12.5677C4.29358 12.633 4.46263 12.6667 4.63334 12.6667H6.03334C6.20406 12.6667 6.37311 12.633 6.53083 12.5677C6.68856 12.5024 6.83187 12.4066 6.95258 12.2859C7.0733 12.1652 7.16906 12.0219 7.23439 11.8641C7.29972 11.7064 7.33334 11.5374 7.33334 11.3667V5.96666C7.33334 5.62188 7.19638 5.29121 6.95258 5.04742C6.70879 4.80362 6.37812 4.66666 6.03334 4.66666H4.63334Z"
      fill={props.stroke}
      stroke={props.stroke}
    />
    <path
      d="M14.6667 4.66666V9.33332M14.6667 14.6667V18.6667"
      stroke={props.stroke}
      stroke-linecap="round"
    />
    <path
      d="M13.9667 9.33333C13.6219 9.33333 13.2912 9.47942 13.0474 9.73947C12.8037 9.99952 12.6667 10.3522 12.6667 10.72V13.28C12.6667 13.6478 12.8037 14.0005 13.0474 14.2605C13.2912 14.5206 13.6219 14.6667 13.9667 14.6667H15.3667C15.5374 14.6667 15.7065 14.6308 15.8642 14.5611C16.0219 14.4914 16.1652 14.3893 16.2859 14.2605C16.4066 14.1318 16.5024 13.9789 16.5677 13.8106C16.6331 13.6424 16.6667 13.4621 16.6667 13.28V10.72C16.6667 10.5379 16.6331 10.3576 16.5677 10.1893C16.5024 10.0211 16.4066 9.86824 16.2859 9.73947C16.1652 9.61071 16.0219 9.50857 15.8642 9.43888C15.7065 9.3692 15.5374 9.33333 15.3667 9.33333H13.9667Z"
      fill={props.stroke}
      stroke={props.stroke}
    />
  </svg>
);
